export default "__VITE_ASSET__BVvvn5hy__"